<template>
  <v-tabs full-width class="bb-separator">
    <v-tab>{{ firstLanguage }}</v-tab>
    <div class='d-flex flex-grow-1 align-center gap'>
      <language-menu :open='languageMenuOpen' @update:open='handleLanguageMenuOpen' @selected-language="handleLanguageOption" :languages="otherLanguages"/>
      <edit-button-global/>
      <subtitle-button/>
      <dark-mode-switch class="ml-2" v-if="$vuetify.breakpoint.mdAndUp"/>
      <v-spacer/>
      <gear-options-btn v-if="!$vuetify.breakpoint.mdAndUp"/>
    </div>
  </v-tabs>
</template>

<script>
import LanguageMenu from './LanguageMenu.vue'
import EditButtonGlobal from './EditButtonGlobal.vue';
import SubtitleButton from './SubtitleButton.vue';
import GearOptionsBtn from '../GearOptionsBtn.vue';

import { createMapLangNameToCode, createMapLangCodeToName } from '../../utils/language';
import DarkModeSwitch from '../darkModeSwitch.vue';
import { ref, computed } from 'vue';
import { useEvent } from '../../plugins/vue-gtag';

export default {
  components: {
    LanguageMenu,
    SubtitleButton,
    EditButtonGlobal,
    GearOptionsBtn,
    DarkModeSwitch
  },
  props: {
    language: {
      type: String,
      required: true
    },
    locale: {
      type: String,
      required: true
    }
  },
  setup(props, context) {
    const languageMenuOpen = ref(false);
    const gaLanguageChanged = useEvent('language_changed')
    const gaLanguageMenuOpen = useEvent('language_menu_open');

    const handleLanguageMenuOpen = (newVal)=> {
      languageMenuOpen.value = newVal;
      
      gaLanguageMenuOpen(newVal);
    }

    const mapLangCodeToName = computed(()=>{
      return createMapLangCodeToName(props.locale);
    });

    const mapLangNameToCode = computed(()=>{
      return createMapLangNameToCode(props.locale);
    });

    const firstLanguage = computed(()=>{
      return mapLangCodeToName.value[props.language]
    });

    const otherLanguages = computed(()=>{
      const result = {};
      Object.keys(mapLangNameToCode.value).forEach((key)=>{
        if (key !== firstLanguage.value){
          result[key] = mapLangNameToCode.value[key]; 
        }
      })
      return result
    })

    const handleLanguageOption = (selectedLanguage)=>{
      const selectedLanguageCode = mapLangNameToCode.value[selectedLanguage];
      context.emit('current-language', selectedLanguageCode);
      gaLanguageChanged(selectedLanguageCode);
    }

    return {
      firstLanguage,
      languageMenuOpen,
      handleLanguageMenuOpen,
      handleLanguageOption,
      otherLanguages
    }
  }
}
</script>

<style scoped style='scss'>
  .v-tabs >>> .v-item-group.v-tabs-bar {
    transition: none;
  }
</style>
